import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LuChevronDown } from "react-icons/lu";
import {
  RiApps2AiLine,
  RiLayoutColumnLine,
  RiLayoutGridLine,
  RiSquareLine,
} from "@remixicon/react";
import { cn } from "@/lib/utils";

export type Variations = 1 | 2 | 4;

interface Props {
  value: Variations;
  onChange: (value: Variations) => void;
}

const OPTIONS: { label: string; value: Variations; icon: React.ReactNode }[] = [
  4, 2, 1,
].map((v) => ({
  label: v === 1 ? `${v} Variation` : `${v} Variations`,
  value: v as Variations,
  icon:
    v === 1 ? (
      <RiSquareLine size={14} className="text-brand-primary-400 shrink-0" />
    ) : v === 2 ? (
      <RiLayoutColumnLine size={14} className="text-brand-primary-400 shrink-0" />
    ) : (
      <RiLayoutGridLine size={14} className="text-brand-primary-400 shrink-0" />
    ),
}));

const VariationsDropdown: React.FC<Props> = ({ value, onChange }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex items-center gap-[6px] border-[1px]">
          <RiApps2AiLine size={14} className="text-brand-primary-400 shrink-0" />
          <span className="text-brand-primary-800 text-[12px]">{value}v</span>
          <LuChevronDown className="h-4 w-4 text-brand-primary-new shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="p-1 bg-white shadow-none rounded-[12px] border-0 squircle squircle-radius-[12px] squircle-smooth-[1] squircle-outline-[1px] squircle-outline-color-border-gray"
      >
        {OPTIONS.map(({ label, value: v, icon }) => (
          <DropdownMenuItem
            key={v}
            className={cn(
              "flex gap-2 h-[28px] px-2 py-1 items-center self-stretch cursor-pointer text-brand-primary-800 hover:text-brand-primary-800 text-[12px] hover:bg-selected-gray",
              v === value ? "bg-selected-gray" : "hover:bg-hover-gray",
            )}
            onClick={() => onChange(v)}
          >
            {icon}
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default VariationsDropdown;
